import { createYoutubeEmbedPreviewSrc } from '@/service/utils/createYoutubeLink';

type TSliderVideo = {
    link: string;
    onClick: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
    isPlayVideo: boolean;
};
export const SliderVideo = ({ link, onClick, isPlayVideo }: TSliderVideo) => {
    const pureLink = link.split('?')[0];

    const VideoPreview = () => (
        <div
            style={{ backgroundImage: `url('${createYoutubeEmbedPreviewSrc(pureLink)}')` }}
            className={`slider-item flex-center bg-no-repeat] h-full w-full min-w-full bg-cover bg-center`}
        >
            <button type={'button'} className="transition hover:opacity-90" onClick={onClick}>
                <svg height="48px" version="1.1" viewBox="0 0 68 48" width="68px">
                    <path
                        className="ytp-large-play-button-bg"
                        d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
                        fill="#f00"
                    ></path>
                    <path d="M 45,24 27,14 27,34" fill="#fff"></path>
                </svg>
            </button>
        </div>
    );

    return (
        <div
            className="slider-item relative block h-full w-full min-w-full"
            data-test-id="slider-video"
        >
            {isPlayVideo ? (
                <iframe
                    className="absolute start-0 top-0 h-full w-full"
                    src={`${pureLink}?autoplay=1`}
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            ) : (
                <VideoPreview />
            )}
        </div>
    );
};
